import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import TableCategory, {
  getTableCategoryFilters,
} from "@/components/Tree/TableCategory";
import ListTable from "@/modules/list-table";
import { TABLE_FILTER_TEXT } from "@/modules/table-filter";
import { format, fromNow } from "@/utilities/date";

const RecentlyViewedTable = (listTableProps) => {
  const { t } = useTranslation();

  const defaultColumns = [
    {
      title: t("global:category"),
      dataIndex: "type",
      width: 140,
      className: "type",
      render: (type) => <TableCategory type={type} />,
      filterMode: "tree",
      filters: getTableCategoryFilters(t),
    },
    {
      title: t("global:name"),
      dataIndex: "name",
      className: "table-name",
      render: (name, { id, type }) => (
        <Link to={`/${type}s/${id}`}>{name}</Link>
      ),
      ...TABLE_FILTER_TEXT,
    },
  ];

  const systemColumns = [
    {
      title: t("global:lastViewedAt"),
      dataIndex: "last_viewed_at",
      render: (value) => (
        <Tooltip title={format(value, "LLLL")}>{fromNow(value)}</Tooltip>
      ),
    },
  ];

  const columns = [...defaultColumns, ...systemColumns];

  return <ListTable columns={columns} {...listTableProps} />;
};

export default RecentlyViewedTable;
